module.exports = __webpack_public_path__ + "img/location-amsterdam.f9f1b5b0.jpg";